"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accessorial = void 0;
exports.Accessorial = {
    LIFTGATE_PICKUP: 'LIFTGATE_PICKUP',
    RESIDENTIAL_PICKUP: 'RESIDENTIAL_PICKUP',
    MILITARY_BASE_PICKUP: 'MILITARY_BASE_PICKUP',
    MILITARY_BASE_DELIVERY: 'MILITARY_BASE_DELIVERY',
    AIRPORT_PICKUP: 'AIRPORT_PICKUP',
    AIRPORT_DELIVERY: 'AIRPORT_DELIVERY',
    PICKUP_APPOINTMENT: 'PICKUP_APPOINTMENT',
    DELIVERY_APPOINTMENT: 'DELIVERY_APPOINTMENT'
};
//# sourceMappingURL=accessorial.js.map